import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TagsList } from "@/features/admin/tags/list";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  search: z.string().optional(),
  sort: z.string().optional(),
  tagId: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/tags/")({
  validateSearch: searchSchema,
  component: TagsList,
});
